module.exports = __webpack_public_path__ + "static/media/msgsetting.8444a730.svg";